// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"26ea5be9","190":"75ed4ad3","233":"5ce11011","294":"468572b7","319":"5ae8b71d","417":"b0594841","453":"92304bfe","594":"d8b5c7b3","685":"3512f1f2","951":"d21e13e7"}[chunkId] + ".chunk.js";
};